/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_Nothing_FiresInputs */

const th_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณยังไม่ได้ติดตามสิ่งใด การตั้งค่าด้านล่างจึงยังไม่ทำงาน`)
};

const en_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You follow nothing yet, so none of the settings below can fire.`)
};

const ja_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ何もフォローしていないため、下の設定は動作しません。`)
};

const zh_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你还没有关注任何内容，因此下面的设置都不会触发。`)
};

const es_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no sigues nada, así que ninguno de los ajustes de abajo puede activarse.`)
};

const pt_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ainda não segue nada, então nenhuma das opções abaixo pode disparar.`)
};

const id_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda belum mengikuti apa pun, jadi tidak ada pengaturan di bawah yang bisa aktif.`)
};

const fr_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous ne suivez encore rien, donc aucun des réglages ci-dessous ne peut se déclencher.`)
};

const tl_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ka pang sinusundan, kaya walang setting sa ibaba ang maaaring gumana.`)
};

const vi_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn chưa theo dõi gì cả, nên chưa thiết lập nào bên dưới có thể kích hoạt.`)
};

const ko_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 팔로우한 것이 없어 아래 설정 중 어느 것도 작동하지 않습니다.`)
};

const de_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du folgst noch nichts, deshalb kann keine der Einstellungen unten auslösen.`)
};

const ru_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы ещё ни на что не подписаны, поэтому ни одна настройка ниже не сработает.`)
};

const tr_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz hiçbir şeyi takip etmiyorsunuz, bu yüzden aşağıdaki ayarların hiçbiri çalışamaz.`)
};

const it_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non segui ancora nulla, quindi nessuna delle impostazioni qui sotto può attivarsi.`)
};

const pl_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic jeszcze nie obserwujesz, więc żadne z ustawień poniżej nie zadziała.`)
};

const uk_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви ще ні за чим не стежите, тож жодне з налаштувань нижче не спрацює.`)
};

const hi_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप अभी कुछ भी फ़ॉलो नहीं करते, इसलिए नीचे की कोई भी सेटिंग काम नहीं करेगी।`)
};

const ar_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا تتابع شيئًا بعد، لذا لن يعمل أي من الإعدادات أدناه.`)
};

const ms_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda belum mengikuti apa-apa, jadi tiada tetapan di bawah boleh berfungsi.`)
};

const bn_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি এখনও কিছু অনুসরণ করেন না, তাই নিচের কোনও সেটিং কাজ করবে না।`)
};

const zh_tw2_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你尚未追蹤任何內容，因此下方設定都不會觸發。`)
};

const zh_hk2_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你尚未追蹤任何內容，因此下方設定都不會觸發。`)
};

const ur_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ ابھی کچھ فالو نہیں کرتے، اس لیے نیچے کی کوئی ترتیب کام نہیں کرے گی۔`)
};

const fa_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز چیزی را دنبال نمی‌کنید، پس هیچ‌یک از تنظیمات زیر کار نمی‌کند.`)
};

const sw_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hujafuatilia chochote bado, kwa hivyo hakuna mpangilio hapa chini utakaofanya kazi.`)
};

const nl_follow_nothing_fires = /** @type {(inputs: Follow_Nothing_FiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je volgt nog niets, dus geen van de instellingen hieronder kan afgaan.`)
};

/**
* | output |
* | --- |
* | "You follow nothing yet, so none of the settings below can fire." |
*
* @param {Follow_Nothing_FiresInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const follow_nothing_fires = /** @type {((inputs?: Follow_Nothing_FiresInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_Nothing_FiresInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_follow_nothing_fires(inputs)
	if (locale === "ja") return ja_follow_nothing_fires(inputs)
	if (locale === "zh") return zh_follow_nothing_fires(inputs)
	if (locale === "es") return es_follow_nothing_fires(inputs)
	if (locale === "pt") return pt_follow_nothing_fires(inputs)
	if (locale === "id") return id_follow_nothing_fires(inputs)
	if (locale === "fr") return fr_follow_nothing_fires(inputs)
	if (locale === "tl") return tl_follow_nothing_fires(inputs)
	if (locale === "vi") return vi_follow_nothing_fires(inputs)
	if (locale === "ko") return ko_follow_nothing_fires(inputs)
	if (locale === "de") return de_follow_nothing_fires(inputs)
	if (locale === "ru") return ru_follow_nothing_fires(inputs)
	if (locale === "tr") return tr_follow_nothing_fires(inputs)
	if (locale === "it") return it_follow_nothing_fires(inputs)
	if (locale === "pl") return pl_follow_nothing_fires(inputs)
	if (locale === "uk") return uk_follow_nothing_fires(inputs)
	if (locale === "hi") return hi_follow_nothing_fires(inputs)
	if (locale === "ar") return ar_follow_nothing_fires(inputs)
	if (locale === "ms") return ms_follow_nothing_fires(inputs)
	if (locale === "bn") return bn_follow_nothing_fires(inputs)
	if (locale === "zh-TW") return zh_tw2_follow_nothing_fires(inputs)
	if (locale === "zh-HK") return zh_hk2_follow_nothing_fires(inputs)
	if (locale === "ur") return ur_follow_nothing_fires(inputs)
	if (locale === "fa") return fa_follow_nothing_fires(inputs)
	if (locale === "sw") return sw_follow_nothing_fires(inputs)
	if (locale === "nl") return nl_follow_nothing_fires(inputs)
	return en_follow_nothing_fires(inputs)
});